/**
 * Adyen v6 onBinValue passes { binValue, type, encryptedBin?, uuid? }.
 * Older examples assumed a raw string. Normalize both shapes for Forter preAuth.
 */
export function extractAdyenBinValue(payload) {
	if (payload == null || payload === '') {
		return null;
	}

	if (typeof payload === 'string' || typeof payload === 'number') {
		return String(payload);
	}

	if (typeof payload === 'object') {
		const candidate = payload.binValue ?? payload.issuerBin;

		if (candidate == null || candidate === '') {
			return null;
		}

		return String(candidate);
	}

	return null;
}
